import get from 'lodash.get';

const getDialog = (rootState) => get(rootState, 'dialogs.activeDialog', null);

export default getDialog;
